import React from "react";
import { Ets2AffidavitPlaceOfDeliveryDTO } from "../dtos/Ets2AffidavitPlaceOfDeliveryDTO";
import { Ets2PlaceOfDeliveryStatus } from "../enums/ets2PlaceOfDeliveryStatus";
import InfoItemInline from "features/shared/components/infoItem/InfoItemInline";
import { useTranslation } from "react-i18next";
import { formatDate } from "features/shared/helpers/Formatters";

interface Props {
  pod: Ets2AffidavitPlaceOfDeliveryDTO;
}

const Ets2AffidavitExceptionSubDialog = ({ pod }: Props) => {
  // translations
  const t = useTranslation("ets2\\ets2").t;
  const noValue = t("ets2AffidavitExceptionSubDialog.noValue");
  const isRejected = pod.ets2PlaceOfDeliveryStatus === Ets2PlaceOfDeliveryStatus.Rejected;

  // sub-renders
  const renderDate = (value?: string | null) => {
    if (!value) return noValue;
    const formatted = formatDate(value);
    return formatted || noValue;
  };

  // render
  return (
    <div className="m-4">
      {isRejected ? (
        <div className="mb-2">
          <InfoItemInline
            title=""
            value={pod.rejectionReason || noValue}
            valueBold={false}
            className="justify-content-start"
            titleClassName="d-none"
            valueClassName=""
          />
        </div>
      ) : (
        <>
          <div className="mb-2">
            <InfoItemInline
              title={t("ets2AffidavitExceptionSubDialog.exceptionType")}
              value={pod.exceptionType || noValue}
              includeColon
              titleClassName="col-auto pl-0"
              valueClassName="text-right"
            />
          </div>
          <div className="mb-2">
            <InfoItemInline
              title={t("ets2AffidavitExceptionSubDialog.exceptionFrom")}
              value={renderDate(pod.exceptionFrom)}
              includeColon
            />
          </div>
          <div className="mb-1">
            <InfoItemInline
              title={t("ets2AffidavitExceptionSubDialog.exceptionTo")}
              value={renderDate(pod.exceptionTo)}
              includeColon
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Ets2AffidavitExceptionSubDialog;
